import { useRoutes } from 'react-router-dom';

// routes
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';
import ContabilidadRoutes from './ContabilidadRoutes';
import SucursalesRoutes from './SucursalesRoutes';
import ComprobantesRoutes from './ComprobantesRoutes';
import SuministrosRoutes from './SuministrosRoutes';
import ActivosRoutes from './ActivosRoutes';
import ReportesRoutes from './ReportesRoutes';
import AdministracionEmpleadosRoutes from './AdministracionEmpleadosRoutes';
import TransportistasRoutes from './TransportistasRoutes';
import LogsRoutes from './LogsRoutes';
import DatabasesRoutes from './DatabaseRoutes';
import ArcsaRoutes from './ArcsaRoutes';
import ArcsaRecepcionRoutes from './ArcsaRecepcionRoutes';
import NotificacionesRoutes from './NotificacionesRoutes';
import ProduccionRoutes from './ProduccionRoutes';
// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    return useRoutes([LoginRoutes, MainRoutes, ContabilidadRoutes, SucursalesRoutes, ComprobantesRoutes, SuministrosRoutes, ActivosRoutes, ReportesRoutes, AdministracionEmpleadosRoutes, TransportistasRoutes, LogsRoutes, DatabasesRoutes, ArcsaRoutes, ArcsaRecepcionRoutes, NotificacionesRoutes, ProduccionRoutes]);
}
